import React from 'react';
import packageInfo   from '../../package.json'

export default function Footer({ local_version }) {
    
    return (
        <div>
            <footer className="main-footer">
                <strong>Copyright © 2020 <a href="http://hondix.com.br">Hondix</a>.</strong>
                <div className="float-right d-none d-sm-inline-block">
                    <b>Version</b> {local_version ?? packageInfo.version}
                </div>
            </footer>
            <aside className="control-sidebar control-sidebar-dark">
            </aside>
        </div>
    )
}
